import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IReport, IFarsQueueItem } from '../../../../common/sharedTypes';

export const FETCH_FARS_DATA = '@@FARS_FETCH_FARS_DATA';
export const DATA_TO_ADD = '@@FARS_DATA_TO_ADD';
export const STORE_DATA_TO_EDIT = '@@FARS_STORE_DATA_TO_EDIT';
export const DATA_TO_BE_DELETED = '@@FARS_DATA_TO_BE_DELETED';
export const FATALITY_REPORTS = '@@FARS_FATALITY_REPORTS';
export const REPORT_TO_REMOVE = '@@FARS_REPORT_TO_REMOVE';
export const REMOVE_FROM_QUEUE = '@@FARS_SREMOVE_FROM_QUEUE';
export const GET_FORM_IO_FORM_ID = '@@GET_FORM_IO_FORM_ID';

export const getFarsData = (url: string, dateFilter: any, showSent: boolean) => {
  return async (dispatch) => {
    try {
      Api.post(url, { ...dateFilter, showSent }).then((result: ApiResponse<any>) => {
        dispatch(fetchFarsData(result.data));
        //console.log('getFarsData result', result.data);
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const onReportToRemove = (url: string, reportId) => {
  return async (dispatch, getState) => {
    try {
      Api.post(url, reportId).then((result: ApiResponse<any>) => {
        dispatch(reportToRemove(reportId));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const reportToRemove = (reportId: number) => ({
  type: REPORT_TO_REMOVE,
  value: reportId,
});

export const onDataToEdit = (url: string, data) => (dispatch, getState) =>
  new Promise<any>(function (resolve, reject) {
    Api.put(url, data)
      .then((result: ApiResponse<any>) => {
        // Remember to update the call to return a Success / Error instead of the same item back
        if (result.data != undefined) {
          let currentFARSData = getState().farsSearchData.farsData.map(
            (item) => {
              if (item.id == result.data.id) item = result.data;
              return item;
            }
          );
          //dispatch(fetchFarsData(currentFARSData));
          //console.log('currentFARSData result', currentFARSData);
        }
        dispatch(dataToEdit(result.data));
        resolve(result);
        //console.log('currentFARSData result', result);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const dataToEdit = (item: any) => ({
  type: STORE_DATA_TO_EDIT,
  value: item,
});

export const dataToAdd = (items) => ({
  type: DATA_TO_ADD,
  value: items,
});

export const dataToRemove = (reportId) => ({
  type: DATA_TO_BE_DELETED,
  value: reportId,
});

export const fetchFarsData = (items) => ({
  type: FETCH_FARS_DATA,
  value: items,
});

export const getReports = (url: string) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.get(url)
      .then((result: ApiResponse<any>) => {
        dispatch(reducegetReports(result.data));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reducegetReports = (result: IReport[]) => {
  return {
    type: FATALITY_REPORTS,
    value: result,
  };
};

export const sendToNhtsa = (url: string, id: number) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.post(url, id)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceRemoveFromQueue(id));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const deleteFars = (url: string, id: number) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.post(url, id)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceRemoveFromQueue(id));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceRemoveFromQueue = (id: number) => {
  return {
    type: REMOVE_FROM_QUEUE,
    value: id,
  };
};

export const getFormIoFormId = () => {
  return (dispatch, getState) => {
    const state = getState();
    Api.get(state.Application.backendURL + 'farsReport/GetFormIoFormId').then(
      (response: ApiResponse<string>) =>
        dispatch(gotFormIoFormId(response.data))
    );
  };
};

const gotFormIoFormId = (formId: string) => ({
  type: GET_FORM_IO_FORM_ID,
  value: formId,
});
